import hljs from "highlight.js/lib/core";
import HLJSPluginproperties from "highlight.js/lib/languages/properties";
hljs.registerLanguage("properties", HLJSPluginproperties);
import HLJSPluginapache from "highlight.js/lib/languages/apache";
hljs.registerLanguage("apache", HLJSPluginapache);
import HLJSPlugincLike from "highlight.js/lib/languages/c-like";
hljs.registerLanguage("c-like", HLJSPlugincLike);
import HLJSPlugincpp from "highlight.js/lib/languages/cpp";
hljs.registerLanguage("cpp", HLJSPlugincpp);
import HLJSPluginbash from "highlight.js/lib/languages/bash";
hljs.registerLanguage("bash", HLJSPluginbash);
import HLJSPluginc from "highlight.js/lib/languages/c";
hljs.registerLanguage("c", HLJSPluginc);
import HLJSPlugincsharp from "highlight.js/lib/languages/csharp";
hljs.registerLanguage("csharp", HLJSPlugincsharp);
import HLJSPlugincss from "highlight.js/lib/languages/css";
hljs.registerLanguage("css", HLJSPlugincss);
import HLJSPlugincoffeescript from "highlight.js/lib/languages/coffeescript";
hljs.registerLanguage("coffeescript", HLJSPlugincoffeescript);
import HLJSPlugindiff from "highlight.js/lib/languages/diff";
hljs.registerLanguage("diff", HLJSPlugindiff);
import HLJSPlugingo from "highlight.js/lib/languages/go";
hljs.registerLanguage("go", HLJSPlugingo);
import HLJSPluginxml from "highlight.js/lib/languages/xml";
hljs.registerLanguage("xml", HLJSPluginxml);
import HLJSPluginhttp from "highlight.js/lib/languages/http";
hljs.registerLanguage("http", HLJSPluginhttp);
import HLJSPluginjson from "highlight.js/lib/languages/json";
hljs.registerLanguage("json", HLJSPluginjson);
import HLJSPluginjava from "highlight.js/lib/languages/java";
hljs.registerLanguage("java", HLJSPluginjava);
import HLJSPluginjavascript from "highlight.js/lib/languages/javascript";
hljs.registerLanguage("javascript", HLJSPluginjavascript);
import HLJSPluginkotlin from "highlight.js/lib/languages/kotlin";
hljs.registerLanguage("kotlin", HLJSPluginkotlin);
import HLJSPluginless from "highlight.js/lib/languages/less";
hljs.registerLanguage("less", HLJSPluginless);
import HLJSPluginlua from "highlight.js/lib/languages/lua";
hljs.registerLanguage("lua", HLJSPluginlua);
import HLJSPluginmakefile from "highlight.js/lib/languages/makefile";
hljs.registerLanguage("makefile", HLJSPluginmakefile);
import HLJSPluginmarkdown from "highlight.js/lib/languages/markdown";
hljs.registerLanguage("markdown", HLJSPluginmarkdown);
import HLJSPluginnginx from "highlight.js/lib/languages/nginx";
hljs.registerLanguage("nginx", HLJSPluginnginx);
import HLJSPluginobjectivec from "highlight.js/lib/languages/objectivec";
hljs.registerLanguage("objectivec", HLJSPluginobjectivec);
import HLJSPluginphp from "highlight.js/lib/languages/php";
hljs.registerLanguage("php", HLJSPluginphp);
import HLJSPluginphpTemplate from "highlight.js/lib/languages/php-template";
hljs.registerLanguage("php-template", HLJSPluginphpTemplate);
import HLJSPluginperl from "highlight.js/lib/languages/perl";
hljs.registerLanguage("perl", HLJSPluginperl);
import HLJSPluginplaintext from "highlight.js/lib/languages/plaintext";
hljs.registerLanguage("plaintext", HLJSPluginplaintext);
import HLJSPluginpython from "highlight.js/lib/languages/python";
hljs.registerLanguage("python", HLJSPluginpython);
import HLJSPluginpythonRepl from "highlight.js/lib/languages/python-repl";
hljs.registerLanguage("python-repl", HLJSPluginpythonRepl);
import HLJSPluginruby from "highlight.js/lib/languages/ruby";
hljs.registerLanguage("ruby", HLJSPluginruby);
import HLJSPluginrust from "highlight.js/lib/languages/rust";
hljs.registerLanguage("rust", HLJSPluginrust);
import HLJSPluginscss from "highlight.js/lib/languages/scss";
hljs.registerLanguage("scss", HLJSPluginscss);
import HLJSPluginsql from "highlight.js/lib/languages/sql";
hljs.registerLanguage("sql", HLJSPluginsql);
import HLJSPluginshell from "highlight.js/lib/languages/shell";
hljs.registerLanguage("shell", HLJSPluginshell);
import HLJSPluginswift from "highlight.js/lib/languages/swift";
hljs.registerLanguage("swift", HLJSPluginswift);
import HLJSPluginini from "highlight.js/lib/languages/ini";
hljs.registerLanguage("ini", HLJSPluginini);
import HLJSPlugintypescript from "highlight.js/lib/languages/typescript";
hljs.registerLanguage("typescript", HLJSPlugintypescript);
import HLJSPluginyaml from "highlight.js/lib/languages/yaml";
hljs.registerLanguage("yaml", HLJSPluginyaml);
export default hljs;
